const LTI_OAUTH_AFTER_LAUNCH_KEY = 'lti_oauth_after_launch';
const LTI_OAUTH_RETURN_PATH_KEY = 'lti_oauth_return_path';

const shouldStartCanvasApiOAuth = ({ role, hasCanvasApiToken }) => {
    return ['instructor', 'ta'].includes(role) && !hasCanvasApiToken;
};

const markLtiCanvasOauthPending = ({ courseId, returnPath, localStorageRef = localStorage, sessionStorageRef = sessionStorage }) => {
    if (courseId) {
        localStorageRef.setItem('course_id', courseId);
    }

    sessionStorageRef.setItem(LTI_OAUTH_AFTER_LAUNCH_KEY, 'true');
    sessionStorageRef.setItem(LTI_OAUTH_RETURN_PATH_KEY, returnPath);
};

const isLtiCanvasOauthPending = (sessionStorageRef = sessionStorage) => {
    return sessionStorageRef.getItem(LTI_OAUTH_AFTER_LAUNCH_KEY) === 'true';
};

const clearLtiCanvasOauthPending = (sessionStorageRef = sessionStorage) => {
    sessionStorageRef.removeItem(LTI_OAUTH_AFTER_LAUNCH_KEY);
    sessionStorageRef.removeItem(LTI_OAUTH_RETURN_PATH_KEY);
};

const getLtiCanvasOauthReturnPath = (sessionStorageRef = sessionStorage) => {
    return sessionStorageRef.getItem(LTI_OAUTH_RETURN_PATH_KEY) || '/';
};

const resolveAuthTokenAfterApiLaunch = ({ isLtiOauthAfterLaunch, existingAuthToken, apiLaunchToken }) => {
    if (isLtiOauthAfterLaunch && existingAuthToken) return existingAuthToken;
    return apiLaunchToken;
};

export {
    clearLtiCanvasOauthPending,
    getLtiCanvasOauthReturnPath,
    isLtiCanvasOauthPending,
    markLtiCanvasOauthPending,
    resolveAuthTokenAfterApiLaunch,
    shouldStartCanvasApiOAuth,
};
